module.exports = "/images/herculift-logo-small.png?bcfb25be862b20151792610fa0fc6573";